import React, { FC } from "react";

import { useBaseMapShared } from "../../../hooks/sharing/useBaseMapShared";
import { BasemapSelectBase } from "../../MapControls/components/BasemapSelect/BasemapSelectBase";
import { BaseMapItem } from "../../MapControls/components/BasemapSelect/BasemapBlock";

export const BasemapSelect: FC = () => {
  const { data, baseMapName, updateMap } = useBaseMapShared();

  return <BasemapSelectBase items={data as BaseMapItem[]} baseMapName={baseMapName} updateMap={updateMap} />;
};
